import { render, staticRenderFns } from "./activity-list-ai.vue?vue&type=template&id=478aca1a&scoped=true"
import script from "./activity-list-ai.vue?vue&type=script&lang=js"
export * from "./activity-list-ai.vue?vue&type=script&lang=js"
import style0 from "./activity-list-ai.vue?vue&type=style&index=0&id=478aca1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478aca1a",
  null
  
)

export default component.exports